import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styles from './Sidebar.module.scss'
import SearchLocationContext from '../../../context/SearchLocationContext'

const Sidebar = props => {
    const [searchLocationData] = useContext(SearchLocationContext)

    return <div className={`${styles.sidebarWrapper} ${searchLocationData.activeLocationId === null ? '' : styles.detailsMode }`} id="sidebar">{props.children}</div>
}

Sidebar.propTypes = {
    children: PropTypes.any,
}

export default Sidebar
